import React from 'react';
import { DropdownList, Multiselect } from 'react-widgets'
import 'react-widgets/dist/css/react-widgets.css'
import '../components/Switch.css'

// This is just wrong ... not sure how we should access this data ...
// Should be coming from the App ... maybe revisit after redux?
import GameList from '../data/GameList'
import PlayerList from '../data/PlayerList' // ditto

class PlayerRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // leaving playerId in props because we don't edit it
      // leaving name in props because we don't edit it
      score: props.score,
      winner: props.winner,
      position: props.position,
    };
  }

  // https://reactjs.org/docs/forms.html in section "Handling Multiple Inputs"
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleFocus(event) {
    event.target.select();
  }

  render() {
    return (
        <tr className="playerRow">
          <td className="playerRow_name">{this.props.name}</td>
          <td className="playerRow_score">
            <input type="text"
              name="score"
              className="playerRow_score_input"
              value={this.state.score}
              onChange={(event) => this.handleInputChange(event)}
              onClick={(event) => this.handleFocus(event)}/>
          </td>
          <td className="playerRow_winner">
            <label className="switch">
              <input type="checkbox" name="winner" defaultChecked={(this.state.winner) ? "checked" : ""} onChange={(event) => this.handleInputChange(event)}/>
              <span className="slider round"></span>
            </label>
          </td>
          <td className="playerRow_position">
            <input type="text"
              name="position"
              className="playerRow_position_input"
              value={this.state.position}
              onChange={(event) => this.handleInputChange(event)}/>
          </td>
        </tr>
    );
  }
}

// Oh, THIS is the bom!  http://jquense.github.io/react-widgets/
// https://github.com/jquense/react-widgets
class NewEvent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlayers: [],
      selectedGame: null,
      scores: [],
    };
  }

  // onSelect() fires when a user selects an item, but not when they cancel ('x') an item.
  onSelectPlayerList(newPlayer) {
    //console.log('onSelectPlayerList: ' + JSON.stringify(newPlayer));
    const newSelectedPlayers = this.state.selectedPlayers.slice();
    const newScores = this.state.scores.slice();
    this.setState({
      selectedPlayers: newSelectedPlayers.concat(newPlayer),
      scores: newScores.concat({
        playerId: newPlayer.playerId,
        name: newPlayer.name,
        score: 0,
        winner: (newSelectedPlayers.length === 0) ? true : false,
        position: newSelectedPlayers.length + 1,
      }),
    });
  }
  // This fires after a user selects an item, or cancels one.  We need to detect the cancel
  // and figure out who they cancelled and then remove them
  onChangePlayerList(allSelectedPlayers) {
    //console.log('onChangePlayerList: ' + JSON.stringify(allSelectedPlayers));
    if (this.state.selectedPlayers.length > allSelectedPlayers.length) {
      // then we can assume one was removed ...
      this.state.selectedPlayers.map((score, index) => {
        let found = false;
        allSelectedPlayers.forEach((element) => {
          if (element.playerId === score.playerId) {
            found = true;
          }
        });
        if (!found) {
          //console.log('Removing: ' + JSON.stringify(score));
          let newSelectedPlayers = this.state.selectedPlayers.slice();
          newSelectedPlayers.splice(index, 1);
          let newScores = this.state.scores.slice();
          newScores.splice(index, 1);
          this.setState({
            selectedPlayers: newSelectedPlayers,
            scores: newScores,
          });
        }
        return "";
      });
    }
  }

  onChangeGame(event) {
    //console.log('changed game: ' + JSON.stringify(event));
    this.setState({
      selectedPlayers: this.state.selectedPlayers,
      selectedGame: event,
      scores: this.state.scores,
    });
  }

  render() {
    //console.log('render: ' + JSON.stringify(this.state.selectedPlayers));
    let playerTable = '';
    if (this.state.scores.length > 0) {
      const list = this.state.scores.map((score, index) => {
        return (
          <PlayerRow key={score.playerId}
            playerId={score.playerId}
            name={score.name}
            score={score.score}
            winner={score.winner}
            position={score.position}
          />
        );
      });
      playerTable = (
        <div className="div_playerTable">
          <table className="playerTable">
            <thead className="playerTable_header">
              <tr><th>Name</th><th>Score</th><th>Winner</th><th>Position</th></tr>
            </thead>
            <tbody>
              {list}
            </tbody>
          </table>
        </div>
      );
    }
    let gameImage = '';
    if ((this.state.selectedGame != null) && (this.state.selectedGame.logo)) {
      gameImage = <img className="gameimage" src={'/' + this.state.selectedGame.logo} alt={this.state.selectedGame.name} style={{width: '200px'}}/>;
    }

    return (
      <div className="newEvent">
        <h1>New Event</h1>
        <div className="gameimage">{gameImage}</div>
        <DropdownList
          className="gamelist_dropdownlist"
          data={GameList}
          valueField='gameId'
          textField='name'
          placeholder='Select Game'
          onChange={(event) => this.onChangeGame(event)} // need wrapper to move to correct THIS
        />
        {playerTable}
        <Multiselect
          className="gamelist_multiselect"
          data={PlayerList}
          valueField='playerId'
          textField='name'
          placeholder='Select Players'
          onChange={(event) => this.onChangePlayerList(event)}
          onSelect={(event) => this.onSelectPlayerList(event)}
        />
      </div>
    );
  }

}

export default NewEvent;



// WEBPACK FOOTER //
// ./src/containers/NewEvent.js